import { useEffect } from "react";

import { isDueSoon, isInLateSubmissionWindow } from "components/materials/page/helpers";
import { PageType } from "components/server-types";

export const MAX_SECTION_ITEMS_PER_SECTION = 5;
export const MAX_HOME_ITEMS_PER_SECTION = 3;

type CountHandler = (count: number) => void;
export type PageLimitProps = {
  showAll: boolean;
  onCountChanged: CountHandler;
};

export const getMaxItemsPerSection = (hasRole: boolean) =>
  hasRole ? MAX_HOME_ITEMS_PER_SECTION : MAX_SECTION_ITEMS_PER_SECTION;

export const getLimitedDisplayPages = (pages: PageType[], showAll: boolean, hasRole: boolean) => {
  if (showAll) {
    return pages;
  }

  return pages.slice(0, getMaxItemsPerSection(hasRole));
};

export const usePageLimits = (
  pages: PageType[],
  showAll: boolean,
  onCountChanged: CountHandler,
  hasRole: boolean,
) => {
  const limitedPages = getLimitedDisplayPages(pages, showAll, hasRole);

  useEffect(() => {
    if (onCountChanged) {
      onCountChanged(pages.length);
    }
    // eslint-disable-next-line no-object-deps/no-object-deps
  }, [pages.length, onCountChanged]);

  return limitedPages;
};

export const filterOutPagesInOtherSections = (pages: PageType[]) =>
  pages.filter((page) => !isDueSoon(page) && !isInLateSubmissionWindow(page));
